export default __webpack_public_path__ + "node_modules/leaflet/dist/images/marker-icon.png";